var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 22,
    height: 22,
    fill: "#0a1c37",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter-icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "twitter_10_",
    "data-name": "twitter (10)",
    d: "M19.74,6.52A9,9,0,0,0,22,4.179h0a9.419,9.419,0,0,1-2.6.712A4.486,4.486,0,0,0,21.386,2.4a9.024,9.024,0,0,1-2.86,1.092,4.51,4.51,0,0,0-7.8,3.084,4.644,4.644,0,0,0,.1,1.029,12.769,12.769,0,0,1-9.3-4.718A4.51,4.51,0,0,0,2.918,8.912,4.458,4.458,0,0,1,.88,8.356v.05a4.531,4.531,0,0,0,3.614,4.432,4.485,4.485,0,0,1-1.183.149,3.981,3.981,0,0,1-.853-.077,4.555,4.555,0,0,0,4.214,3.142,9.066,9.066,0,0,1-5.593,1.923A8.53,8.53,0,0,1,0,17.914a12.7,12.7,0,0,0,6.919,2.024A12.749,12.749,0,0,0,19.74,6.52Z",
    fill: "#0a1c37"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.66e105821467512c0f667f905c5bf1f1.svg";
export { ForwardRef as ReactComponent };